// docs项目内的页面存在相互跳转的情况：
//   data_synchronization_failure
//   no_message_was_received_ios -> message_notification.md
//   permission_settings_run_in_background
//   device_found_but_connection_failed
//   connection_successful_but_pairing_failed
//   match_successful_but_failed_to_bind_account
//   no_message_was_received_ios
//   no_message_was_received_ios -> wechat_new_message.md

import { encode } from 'qss';
import { Query } from './Query';

const getAbsolutePath = (relativePath: string) => {
  const a = document.createElement('a');
  a.href = relativePath;
  return a.href;
};

export const converter = (
  content: string,
  { model, locale }: Query,
): string => {
  content = content.replace(
    /\{\{(data_synchronization_failure|no_message_was_received_ios|permission_settings_run_in_background|device_found_but_connection_failed|connection_successful_but_pairing_failed|match_successful_but_failed_to_bind_account)\}\}/g,
    (match, p1) => {
      // console.log(match, p1);
      const query: any = { locale };
      if (
        [
          'device_found_but_connection_failed',
          'connection_successful_but_pairing_failed',
          'match_successful_but_failed_to_bind_account',
        ].includes(p1)
      ) {
        query.model = model;
      }
      const relativePath = `../${p1}/index.html${encode(query, '?')}`;
      return getAbsolutePath(relativePath);
    },
  )
  .replace(/images\/wp-content\/uploads\//g, "//cdn.web-global.fds.api.mi-img.com/miwear-docs/user-guide/images/wp-content/uploads/");
  return content;
};
